<template>
  <el-card class="box-card main-card">
      <el-row type="flex" justify="space-between">
        <el-col :span="22">
            <el-form class="search-form" ref="form" :model="searchForm">
                <el-form-item label="通知状态：" label-width="85px">
                    <el-select v-model="searchForm.status" @change="searchFn" style="width:120px" clearable >
                        <el-option v-for="item in statusList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col :span="2" style="textAlign: right;">
            <el-button type="primary" class="pxy-primary" plain size="small" @click="toAdd">添加</el-button>
        </el-col>
    </el-row>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%">
         <el-table-column type="expand">
             <template slot-scope="scope">
                 <div style="padding: 0 30px;boxSizing: border-box;">
                     <p v-html="scope.row.content"></p>
                 </div>
             </template>
         </el-table-column>
        <el-table-column prop="id" label="id"  align="center" ></el-table-column>
        <el-table-column prop="title" label="标题"  align="center" ></el-table-column>
        <el-table-column prop="planSendDate" label="预计发送时间"  align="center" >
            <template slot-scope="scope">
                {{scope.row.planSendDate | formatDateTime}}
            </template>
        </el-table-column>
        <el-table-column prop="planSendDate" label="消息轮播结束时间"  align="center" >
          <template slot-scope="scope">
            {{scope.row.noticeEndDate| formatDateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="通知状态"  align="center" >
            <template slot-scope="scope">
                {{scope.row.status === 1 ?'已通知完':(scope.row.status === 0 ?'未通知完':'')}}
            </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDateTime}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="100">
          <template slot-scope="scope">
              <!-- 已通知完的状态不允许 修改/删除 -->
            <el-button :disabled="scope.row.status === 1" size="small" type="success" @click="handleUpdate(scope.row)">
                修改
            </el-button>
            <el-button :disabled="scope.row.status === 1" size="small" type="danger" @click="handleDelete(scope.row)">
            删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <PageComponent ref="pageInfo"></PageComponent>

  </el-card>

</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";
  export default {
    components: {PageComponent},
    data() {
      return {
        searchForm: {
          periodIndex: ''
        },
        tableData: [],
        statusList: [{
          key: 0, value: '未通知完'
        }, {
          key: 1, value: '已通知完'
        }
        ],
      }
    },
    created() {
    },
    methods: {
        // 获取消息列表
      getNotifyList: function () {
        var params = {};
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        if (this.searchForm.status !== '') {
          params.status = this.searchForm.status;
        }
        this.getRequest('/mncNotice/getList', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      //查询条件更改
      searchFn() {
        var queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr})
        var params = {};
        params.page = 1;
        params.pageSize = 10;
        if (this.searchForm.status !== '') {
          params.status = this.searchForm.status;
        }
        this.getRequest('/mncNotice/getList', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      // 修改消息
      handleUpdate(row) {
          this.$router.push({
              path: '/notify/update',
              query: {
                  handle: 'update',
                  info: JSON.stringify(row)
              }
          })
      },
      // 删除消息
      handleDelete( row) {
        this.postRequestJson("/mncNotice/delete",
          {
            id: row.id,
          }).then(resp => {
          if (resp && resp.status == 200) {
            Message.success('删除消息成功！')
            this.getNotifyList();
          }
        });
      },
      // 添加消息
      toAdd() {
          this.$router.push({
              path: '/notify/add',
          })
      }
    },
    mounted: function () {
      this.getNotifyList()
      this.$refs.pageInfo.initPagenator(this.getNotifyList, 10);
    }
  }
</script>

